var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-toggler",class:_vm.classes},[_c('div',{staticClass:"app-toggler__indicator",on:{"click":_vm.toggle}}),_c('div',{staticClass:"app-toggler__label",domProps:{"innerHTML":_vm._s(_vm.label)},on:{"click":_vm.toggle}})])}
var staticRenderFns = []

export { render, staticRenderFns }